module.exports = __webpack_public_path__ + "img/album15_01.d9d4556c.jpg";